// extracted by mini-css-extract-plugin
export default {"nfPage":"notfoundpage_nfPage__T-zM0"};